import { DestinationShippingRate } from '@/models/common/destination-shipping-rate';

export class BusinessShippingRateService {
    public id: number = 0;
    public shippingRateId: number = 0;
    public destination: DestinationShippingRate = new DestinationShippingRate();
    public price: number | null = null;
    public eta?: string;
    public minimumPurchaseEnabled: boolean = false;
    public minimumPurchasePrice: number | null = null;
    public freeShippingEnabled: boolean = false;
    public freeShippingPrice: number | null = null;
    public allowPaymentOnHandingOver: boolean = false;

    constructor(json?: any) {
        if (!json) {
            return;
        }

        Object.assign(this, json, { destination: json.destination ? new DestinationShippingRate(json.destination) : new DestinationShippingRate() });
    }

    public clone(): BusinessShippingRateService {
        const service: BusinessShippingRateService = new BusinessShippingRateService();

        service.id = this.id;
        service.shippingRateId = this.shippingRateId;
        service.destination = this.destination.clone();
        service.price = this.price;
        service.eta = this.eta;
        service.minimumPurchaseEnabled = this.minimumPurchaseEnabled;
        service.minimumPurchasePrice = this.minimumPurchasePrice;
        service.freeShippingEnabled = this.freeShippingEnabled;
        service.freeShippingPrice = this.freeShippingPrice;
        service.allowPaymentOnHandingOver = this.allowPaymentOnHandingOver;

        return service;
    }
}
